import {Navigate} from "react-router-dom";

// خانه‌ی هر نقش — همان مسیری که login.jsx بعد از ورود به آن می‌فرستد.
const HOME_BY_ROLE = {
    ADMIN: "/dashboard/admin-home",
    OPERATOR: "/dashboard/operator-home",
    // A supervisor's home IS the live board — it is the whole reason they have an account.
    SUPERVISOR: "/dashboard/chats",
};

const DEFAULT_ROLE = "OPERATOR";

/**
 * علاوه بر بررسی ورود، می‌تواند مسیر را به نقش‌های مشخصی محدود کند:
 *   <ProtectedRoute roles={["ADMIN"]}> ... </ProtectedRoute>
 *
 * نقش از همان کلید localStorage خوانده می‌شود که dashboard.jsx برای ساختن منو استفاده می‌کند.
 * این فقط یک لایه‌ی UI است تا اپراتور با تایپ دستی آدرس به صفحه‌ی ادمین نرسد و با ۴۰۳ روبه‌رو
 * نشود؛ کنترل واقعی دسترسی همچنان @PreAuthorize بک‌اند است.
 */
/** Both tokens present — the same test ProtectedRoute applies. */
export function hasSession() {
    try {
        return Boolean(localStorage.getItem('refresher-token') && localStorage.getItem('access-token'));
    } catch (e) {
        return false;
    }
}

/** Where a signed-in user of this role belongs. */
export function homeForRole(role) {
    return HOME_BY_ROLE[role] || HOME_BY_ROLE[DEFAULT_ROLE];
}

/**
 * The root of the site. It used to render the login form unconditionally — as did /login — so
 * anything that opened the app at "/" (the installed app's start_url, tapping the home-screen icon,
 * a notification that opens the site root) showed a signed-in operator the login form. They read
 * that as "it threw me out", signed in again, and were shown it again the next time. Signed in →
 * straight to their home; otherwise the login form.
 */
export const RootRedirect = () => {
    if (hasSession()) {
        let role = DEFAULT_ROLE;
        try { role = localStorage.getItem("role") || DEFAULT_ROLE; } catch (e) { /* ignore */ }
        return <Navigate to={homeForRole(role)} replace/>;
    }
    return <Navigate to="/login" replace/>;
};

const ProtectedRoute = ({children, roles}) => {
    const isAuthenticated = hasSession();

    if (!isAuthenticated) {
        return <Navigate to="/login" replace={false}/>;
    }

    if (roles && roles.length) {
        const role = localStorage.getItem("role") || DEFAULT_ROLE;
        if (!roles.includes(role)) {
            return <Navigate to={HOME_BY_ROLE[role] || HOME_BY_ROLE[DEFAULT_ROLE]} replace/>;
        }
    }

    return children;
};


export default ProtectedRoute;
